<div class="suscribe-area py-10">
  <div class="container px-4 lg:px-0">
    <div
      class="suscribe-content flex flex-wrap items-center justify-between md:py-5 xl:py-0"
    >
      <!-- Left Section: Images -->
      <div class="relative w-full md:w-6/12 flex justify-center">
        <img
          src="/images/suscribe/1.png"
          alt="Placeholder Image"
          class="w-full object-cover h-full rounded-lg"
        />
      </div>

      <!-- Right Section: Form -->
      <div class="w-full md:w-5/12 md:mt-0 lg:pr-8 px-4 lg:pl-0 py-5 lg:py-0">
        <div class="subscribe-form xl:w-[569px] ml-auto">
          <h2 class="title">Subscribe</h2>
          <p class="description mb-14">
            Subscribe to our newsletter to keep up to date with our progress.
          </p>
          <form [formGroup]="subscribeForm">
            <div class="mb-4">
              <input
                type="email"
                placeholder="Email Address"
                class="form-control w-full"
                formControlName="email"
              />
            </div>
            <div
              *ngIf="
                subscribeForm.get('email')?.invalid &&
                subscribeForm.get('email')?.touched
              "
              class="error-message"
            >
              Please enter a valid email address.
            </div>
            <button
              pButton
              type="button"
              class="w-full submit-btn"
              [disabled]="isSubmitting || subscribeForm.invalid"
              (click)="onSubmit()"
            >
              {{ isSubmitting ? "Submitting..." : "Subscribe" }}
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
